import * as React from 'react'
import type {SVGProps} from 'react'
const SvgTooltip = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} viewBox="0 0 15 15" {...props}>
        <path
            fill="#375481"
            fillRule="evenodd"
            d="M7.5 0a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m.203 9.75a.96.96 0 0 0-.953.944c0 .498.424.931.953.931.54 0 .964-.433.964-.931a.963.963 0 0 0-.964-.944m.012-6c-.531 0-.965.236-.965.472v3.752l.009.067c.064.239.469.397.956.397.556 0 .952-.188.952-.464V4.222l-.008-.058c-.059-.215-.434-.414-.944-.414"
        />
    </svg>
)
export default SvgTooltip
